import { render, staticRenderFns } from "./Additionals.vue?vue&type=template&id=50ea9d34&"
import script from "./Additionals.vue?vue&type=script&lang=js&"
export * from "./Additionals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports